import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
// import videoSource from "../../assets/videos/VI.mp4";
// import videoSource1 from "../../assets/videos/VI_Demo.mp4";
import architecture from "../../assets/images/resource/analyze-video.png";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/ai-agents.png";
// import vi from "./../../assets/images/icons/vi.jpg";
// import msa from "./../../assets/images/icons/msa.png";

const VideoIndexer = () => {
  pageTitle("Video Insight Pipeline");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${SorBanner})` }}
      >
        {/* <img src={SorBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          {/* <img
            src={msa}
            alt="Microsoft azure"
            className="ai-overlay-corner-img"
          /> */}
          <div className="ai-overlay-center-text">
            <h2 className="aai-h2 mt-0">Video Insight Pipeline</h2>
            {/* <p>
              <img src={vi} alt="Microsoft azure" style={{ height: "30px" }} />{" "}
              Video Indexer
            </p> */}
          </div>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container-data-engineering container">
          <div className="siw-rpa-content">
            {/* <span className="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div className="siw-rpa-text">
              <p>
                Turn uploaded videos into structured insights with an automated
                workflow.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3 className="pb-2">Key Capabilities</h3>
              <p>
                This solution converts raw video content into meaningful,
                structured insights through a streamlined AI and data processing
                workflow:
              </p>
              <p
                className="py-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Six-Step Workflow
              </p>
              <ol>
                <li>Input – Raw video files are uploaded into the system.</li>
                <li>
                  Extract – Machine learning workflows break videos into image
                  frames.
                </li>
                <li>
                  Store – Extracted frames are stored securely for further
                  analysis.
                </li>
                <li>
                  Analyze – AI APIs identify patterns, objects, and valuable
                  data points.
                </li>
                <li>
                  Integrate – Processed data is unified into a connected data
                  fabric.
                </li>
                <li>
                  Visualize – Insights are presented through reports and
                  dashboards.
                </li>
              </ol>
            </div>
          </div>

          <div className="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated AI Agents.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the <strong>Video Insight Pipeline</strong>
              ,
              <br />
              Click 👉{" "}
              <a
                href="https://agents.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Video Insight Pipeline
              </a>
              .
            </p>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px" }}>
        <div className="siw-rpa-desc mt-0">
          <h3>Architecture</h3>
          <p className="pt-2">
            This architectural diagram illustrates a streamlined data pipeline
            designed to extract meaningful insights from raw video content using
            AI Agents. The process begins by deconstructing video files into
            individual frames through machine learning workflows, which are then
            stored for deep computational analysis. These images are processed
            by artificial intelligence APIs to identify specific patterns and
            data points, effectively transforming unstructured visual media into
            structured digital information. Ultimately, this refined data is
            integrated into a unified fabric where it can be translated into
            visual reports, allowing users to easily interpret complex trends
            and findings.
          </p>
          <img
            src={architecture}
            alt="Video Insight Pipeline"
            className="siw-rpa-desc-img"
          />
        </div>
      </div>

      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing Video Insight Pipeline
              </h3>

              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/Zvr7L3EJX38?si=IjFuwjTyUiYZQMZk"
                  title="Introducing Video Insight Pipeline"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/7I-LlnB7QlE?si=0sVi9gZGfi6s6VtE"
                  title="Watch a Demo Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the <strong>Video Insight Pipeline</strong>,
            Click 👉{" "}
            <a
              href="https://agents.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Video Insight Pipeline
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default VideoIndexer;
